import React from 'react';
import maintenance from '../images/maintenance.jpg';

const About = () => {
  return (
    <section className="about">
      <div className="container">
        <h2 className="about__title" style={{ textAlign: 'left' }}>About Us</h2>
        <div className="about__content">
          <div className="about__text">
            <p className="about__description">
              Fix It All aims to provide you with hassle-free home improvement and
              property management services. You tell us what you need, we make it happen.
              No nonsense. No fuss.
            </p>
            <p className="about__description">
              From Gas engineers and tilers to Plumbers and decorators,
              we've got you covered with Scotland's finest tradespeople.
            </p>
          </div>
          <div className="about__image-container">
            <img
              src={maintenance}
              alt="Professional maintenance tools"
              className="about__image"
              style={{ maxHeight: '300px', width: 'auto' }}
            />
          </div>
        </div>

        <h2 className="about__title" style={{ textAlign: 'left' }}>Project Management</h2>
        <p className="about__description">
          At Fix It All you will find experienced and professional tradesmen
          with an eye for quality and a passion for customer satisfaction.
          We do not accept anything short of perfection and neither should you.
        </p>
      </div>
    </section>
  );
};

export default About;
